import React, { useEffect } from 'react'
import { CONFIG } from './../../Config/config'
import ScriptLoader from './../../Components/ScriptLoader'

const GMap = ({
  onInit = () => {},
  mapSettings = {},
  mapStyle = {},
  isFullScreen = false,
}) => {
  // Setup a unique id we can use to render the Google stuff inside
  const containerId = 'map-' + +new Date()

  useEffect(() => onMapInit(), [])

  const onMapInit = () => {
    const map = new google.maps.Map(
      document.getElementById(containerId),
      mapSettings,
    )
    onInit(map, google)
  }

  return (
    <div
      id={containerId}
      className="GMapRoot"
      style={{
        overflow: 'hidden',
        height: isFullScreen ? '100%' : 700,
        ...mapStyle,
      }}
      cypress_id="campaign-details-map"
    />
  )
}

export default props => (
  <ScriptLoader
    src={`https://maps.googleapis.com/maps/api/js?key=${
      CONFIG.GOOGLE_API_KEY
    }&libraries=drawing,visualization,geometry&v=3.64`}
  >
    <GMap {...props} />
  </ScriptLoader>
)
